<template>
  <div>
    <div class="l-row">
      <form-group label="Variação vinculada ao anúncio" :columns="12">
        <input class="form-input" type="text" v-model="variationTitle" :disabled="true">
      </form-group>
    </div>

    <variation-attributes v-if="variation" :variation="variation" :fromModule="fromModule" :productId="productId"/>

    <div class="divider"><span>Atributos</span></div>

    <attributes :product="variation" v-if="variation" :attributes="category.variations_attributes" :sourceVariation="sourceVariation"/>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'
  import Attributes from '@/components/marketplace/mercadoLivre/announcement/edit/variation/Attributes'
  import VariationAttributes from '@/components/marketplace/mercadoLivre/announcement/variation/VariationAttributes'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      sourceVariation: {
        type: Object,
        required: true
      },
      category: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      productId: {
        type: String
      }
    },
    computed: {
      variationTitle () {
        if (!this.variation || !this.sourceVariation) {
          return false
        }

        const title = [`SKU: ${this.sourceVariation.sku}`]

        if (this.sourceVariation.ean !== null && this.sourceVariation.ean !== undefined && this.sourceVariation.ean !== '') {
          title.push(`EAN: ${this.sourceVariation.ean}`)
        }

        for (let i in Object.keys(this.sourceVariation.attributes)) {
          const name = Object.keys(this.sourceVariation.attributes)[i]
          const value = this.sourceVariation.attributes[name]

          if (value === null || value === undefined) {
            continue
          }

          title.push(`${this.$t(`${name}.label`)}: ${value}`)
        }

        return title.join(' | ')
      }
    },
    components: {
      FormGroup,
      Attributes,
      VariationAttributes
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Single.vue?b12d659e